import { AfterViewInit, EventEmitter } from '@angular/core';
import { ModalConfig } from '../../../model/modal-config';
import { PageNames } from '../../../shared/page-names.enum';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { Error } from '../../../model/error';
var TrialComparisonComponent = /** @class */ (function () {
    function TrialComparisonComponent(navigationService) {
        this.navigationService = navigationService;
        this.emitClose = new EventEmitter();
        this.ownerComponent = PageNames.TRIAL_COMPARISON_MODAL;
        this.activationPending = false;
        this.chosenTrial = undefined;
    }
    TrialComparisonComponent.prototype.close = function () {
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(PageNames.TRIAL_COMPARISON_MODAL);
    };
    TrialComparisonComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
    };
    TrialComparisonComponent.prototype.setActivationPending = function (isPending) {
        this.activationPending = isPending;
    };
    TrialComparisonComponent.prototype.setTimeOut = function (isTimeout) {
        if (isTimeout) {
            var timeoutError = new Error('timeout', 'There is no response. Please try again later.');
            Emitter.of(EmitterConstants.OPEN_TRIAL_ACTIVATION_TIMEOUT).emit({
                trial: this.chosenTrial,
                component: this.ownerComponent,
                error: timeoutError
            });
        }
    };
    TrialComparisonComponent.prototype.setActivatedTrial = function ($event) {
        this.chosenTrial = $event;
    };
    return TrialComparisonComponent;
}());
export { TrialComparisonComponent };
